
import { hubConnection } from 'signalr-no-jquery';
import { SignalRReceiveEvent, SignalRSendEvent } from '../Component/Model/Enum/SignalREvents';
import { SignalRHubs } from '../Component/Model/Enum/SignalRHubs';


declare global {
    interface Window { config: any }
}


// Starts the SignalR connection


export class BaseClient {
    private _connection: any;

    protected removeListener = (channel: SignalRReceiveEvent, callBack: (args: any[]) => void) => {
        this._connection.off(SignalRReceiveEvent[channel].toString(), callBack);
    }

    protected sendPayload = async <T>(channel: SignalRSendEvent, payload: T, hubName: SignalRHubs, callback: any, url? : string) => {
        const signalrConnection = hubConnection(url);
        if (signalrConnection) {
            try {
                const channelString = SignalRSendEvent[channel].toString();
                this._connection = signalrConnection.createHubProxy(SignalRHubs[hubName].toString());
                this._connection.on('UpdateStatus', (message: any, secondMessage: any) => {
                    callback(message, secondMessage)
                });
                signalrConnection.start().done(() => {
                    this._connection.invoke(channelString, payload);
                });


            }
            catch (e) {
                console.error('sendPayload error', e);
            }
        }
        else {
            console.warn('No connection, cannot send payload!')
        }
    }

}